<template>
  <div id="app">
      <router-view :key="localeKey"></router-view>
      <Footer/>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0,
      localeKey: (this.$i18n && this.$i18n.locale) || localStorage.getItem('lang') || 'zh_cn',
    };
  },
  watch: {
    '$i18n.locale'(locale) {
      this.localeKey = locale || 'zh_cn';
      this.getBaseInfo();
    },
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        const publicRoutes = ['login', 'register'];
        if(!localStorage.getItem('token') && !publicRoutes.includes(this.$route.name)){
          this.$router.push({path:'/Login'})
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    },
    handleLanguageChanged(event) {
      const next =
        (event && event.detail && event.detail.appLang) ||
        (this.$i18n && this.$i18n.locale) ||
        localStorage.getItem('lang') ||
        'zh_cn';
      this.localeKey = next;
      this.getBaseInfo();
    },
  },
  created(){
    this.getBaseInfo();
    window.addEventListener('app-language-changed', this.handleLanguageChanged);
  },
  beforeDestroy() {
    window.removeEventListener('app-language-changed', this.handleLanguageChanged);
  },
}
</script>

<style lang="less">
@import "@/assets/css/base.less";
@font-face {
  font-family: 'Miracle';
  font-style: normal;
  font-weight: 400 900;
  font-display: swap;
  src: url('/font/Miracle.woff2') format('woff2-variations'), url('/font/Miracle.woff2') format('woff2 supports variations');
  unicode-range: U+d, U+20-7e, U+a0-132, U+134-17e, U+181, U+18a, U+18f, U+192, U+1a0-1a1, U+1af-1b0, U+1b3-1b4, U+1c4-1ce, U+1d4, U+1e5-1e7, U+1e9-1eb, U+1ef, U+1fa-21b, U+21f, U+226-228, U+22a-22d, U+230-233, U+237, U+253, U+257, U+259, U+292, U+2b9-2bc, U+2be-2bf, U+2c6-2cc, U+2d8-2dd, U+300-304, U+306-30c, U+30f, U+311-312, U+31b, U+323-324, U+326-328, U+32e, U+331, U+335, U+337-338, U+394, U+3a3, U+3a9, U+3bc, U+3c0, U+400-45f, U+462-463, U+46a-46b, U+472-475, U+48a-4a5, U+4a8-4ff, U+510-513, U+51a-51d, U+524-529, U+52e-52f, U+1e08-1e09, U+1e0c-1e0f, U+1e14-1e17, U+1e1c-1e1d, U+1e20-1e21, U+1e24-1e25, U+1e2a-1e2b, U+1e2e-1e2f, U+1e36-1e37, U+1e3a-1e3b, U+1e42-1e49, U+1e4c-1e53, U+1e5a-1e5b, U+1e5e-1e69, U+1e6c-1e6f, U+1e78-1e7b, U+1e80-1e85, U+1e8e-1e8f, U+1e92-1e93, U+1e97, U+1e9e, U+1ea0-1ef9, U+2007-200b, U+2010, U+2012-2015, U+2018-201a, U+201c-201e, U+2020-2022, U+2026, U+2030, U+2032-2033, U+2039-203a, U+2044, U+2052, U+2070, U+2074-2079, U+2080-2089, U+20a1, U+20a3-20a4, U+20a6-20a7, U+20a9, U+20ab-20ae, U+20b1-20b2, U+20b4-20b5, U+20b8-20ba, U+20bc-20bd, U+2113, U+2116, U+2122, U+2126, U+212e, U+2202, U+2205-2206, U+220f, U+2211-2212, U+2215, U+2219-221a, U+221e, U+222b, U+2248, U+2260, U+2264-2265, U+25ca, U+27e8-27e9, U+f8ff, U+fb01-fb02;
}
body,html,*{
  font-family: 'Miracle';
  font-weight: 600 !important;
}
body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: 230px;
}
body .van-toast .van-toast__icon {
  font-size: 50px;
}
@media (min-width: 48rem) {
  body .van-toast {
    width: auto;
    max-width: 14rem;
    padding: 0.75rem 0.875rem;
    font-size: 0.95rem;
    line-height: 1.45;
    border-radius: 0.9rem;
  }

  body .van-toast .van-toast__icon {
    font-size: 1.35rem;
  }
}
*, :after, :before {
  box-sizing: border-box;
}
</style>
